module.exports = __webpack_public_path__ + "../resources/images/illustration_search_file-6f463e3a7680232670544007fac2eded.svg";